import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0 w-[200px] md:w-[240px]">
            <div className="relative">
              <div className="absolute inset-0 bg-accent-400/20 rounded-[2.5rem] blur-xl"></div>
              <img
                src={appInfo.image}
                alt="黑料视频 App — 随时随地吃瓜爆料，高清在线观看"
                className="relative w-full h-auto rounded-[2.5rem]"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
              {appInfo.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-[560px] lg:max-w-none">
              {appInfo.desc}
            </p>
            <div className="grid grid-cols-2 gap-x-6 gap-y-2 mb-6">
              {appInfo.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </div>
                  <span>{f}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line text-lg"></i>
                App Store 下载
              </button>
              <button className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-secondary-500 text-background-50 font-semibold text-sm hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}